module.exports = __webpack_public_path__ + "img/indexType_2.d1a1295b.png";